module.exports = __webpack_public_path__ + "img/star-filled-red.a23ac0ab.svg";